export const isFirefox = typeof InstallTrigger !== 'undefined';
